export const useGoogleMapHelpers = async () => {
  const { $googleApiPromise } = useNuxtApp()
  const loadedGoogle = (await $googleApiPromise) as typeof google

  const tileCoordsToBBox = (
    mapProjection: google.maps.Projection | undefined,
    coord: google.maps.Point,
    zoom: number,
    tileWidth: number,
    tileHeight: number,
  ) => {
    // scale is because the number of tiles shown at each zoom level double.
    const scale = Math.pow(2, zoom)

    // A point is created for the north-east and south-west corners, calculated
    // by taking the tile coord and multiplying it by the tile's width and the map's scale.
    const ne = mapProjection?.fromPointToLatLng(
      new loadedGoogle.maps.Point(((coord.x + 1) * tileWidth) / scale, (coord.y * tileHeight) / scale),
    )
    const sw = mapProjection?.fromPointToLatLng(
      new loadedGoogle.maps.Point((coord.x * tileWidth) / scale, ((coord.y + 1) * tileHeight) / scale),
    )

    if (!ne || !sw) {
      return []
    }

    return [sw.lng(), sw.lat(), ne.lng(), ne.lat()]
  }

  const generateLayerOptions = (
    mapProjection: google.maps.Projection | undefined,
    layerKey: string,
    duoPPKey?: string,
  ): google.maps.ImageMapTypeOptions => {
    const TILE_SIZE = 256

    return {
      getTileUrl: function (coord: google.maps.Point, zoom: number) {
        const boundBox = tileCoordsToBBox(mapProjection, coord, zoom, TILE_SIZE, TILE_SIZE)

        const query = new URLSearchParams({
          SERVICE: "WMS",
          VERSION: duoPPKey ? "1.1.1" : "1.3.0",
          REQUEST: "GetMap",
          FORMAT: "image/png",
          TRANSPARENT: "true",
          STYLES: "",
          WIDTH: TILE_SIZE.toString(),
          HEIGHT: TILE_SIZE.toString(),
          LAYERS: layerKey,
          BBOX: duoPPKey
            ? `${boundBox[0]},${boundBox[1]},${boundBox[2]},${boundBox[3]}`
            : `${boundBox[1]},${boundBox[0]},${boundBox[3]},${boundBox[2]}`,
        })
        query.append(duoPPKey ? "SRS" : "CRS", "EPSG:4326")

        if (duoPPKey) {
          return `${duoppBaseUrl}/${duoPPKey}&${query}`
        } else {
          return `${pdokBaseUrl}?${query}`
        }
      },
      tileSize: new loadedGoogle.maps.Size(TILE_SIZE, TILE_SIZE),
      name: layerKey,
    }
  }

  return {
    generateLayerOptions,
  }
}
